import PropTypes from 'prop-types';
import { Tween } from 'react-gsap';
import classnames from 'classnames';
import Section from '../Section.jsx';
import styles from './SectionImage.module.scss';

function SectionImage({ scrub, start, end, src, className, credit, creditClassName, children }) {
  return (
    <Section scrub={ scrub } start={ start } end={ end } className={ styles.section }>
      <Tween from={{ scale: 1.5 }} to={{ scale: 1 }}>
        <div
          className={ classnames(styles.container, className) }
          style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/${src}')` }}
        >
          { children }

          {
            credit && (
              <div className={ classnames(styles.credit, creditClassName) }>
                { credit }
              </div>
            )
          }
        </div>
      </Tween>
    </Section>
  );
}

SectionImage.propTypes = {
  scrub: PropTypes.bool,
  start: PropTypes.string,
  end: PropTypes.string,
  src: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  credit: PropTypes.node,
  creditClassName: PropTypes.string,
  children: PropTypes.node,
};

export default SectionImage;
